import { some as someObject } from 'lodash'

export function isBillingAddressEmpty (billingAddress) {
    return someObject(billingAddress, (a) => !!a)
}
